<template>
    <div id="app">
        <nav class="nav-bar" :style="isFixed ? 'padding-bottom: .5rem;' : ''">
            <div class="logos">
                <img v-if="!isFixed" class="hkp_logo" src="https://cdn.runderful.cn/media-library/bookfairbj/upload/hkp_logo_A.png?x-oss-process=style/width_fixed_320" alt="香港馆书展">
                <div class="header-logo-item">
                    <div class="header-logo-item-info organiser-img">
                        <p>{{ $t('nav.organiser') }}:</p>
                        <div class="flex">
                            <img class="logo-3" src="https://sup-all.oss-cn-hongkong.aliyuncs.com/bookfairbj/upload/zb-logo.svg?v=1.2" alt="" />
                            <!-- <img class="logo-6" src="https://sup-all.oss-cn-hongkong.aliyuncs.com/media-library/bookfairbj/upload/logo-6.svg" alt="" /> -->
                        </div>
                    </div>
                    <div class="header-logo-item-info">
                        <p>{{ $t('nav.CoOrganizers') }}:</p>
                        <div class="flex co-organizers">
                            <img src="https://sup-all.oss-cn-hongkong.aliyuncs.com/bookfairbj/upload/gb-logo.svg" alt="">
                            <!-- <img class="logo-1" src="https://sup-all.oss-cn-hongkong.aliyuncs.com/media-library/bookfairbj/upload/cb-2.svg" alt=""> -->
                        </div>
                    </div>
                    <!-- <div class="header-logo-item-info">
                        <p>{{ $t('nav.Sponsors') }}:</p>
                        <div class="flex">
                            <a href="/">
                                <img src="@/assets/imgs/logo3.png" alt="" />
                            </a>
                            <a href="/">
                                <img src="@/assets/imgs/logo8.png" alt="" />
                            </a>
                        </div>
                    </div> -->
                </div>
                <div class="header-logo-item header-logo-item-down">
                    <div class="header-logo-item-info">
                        <p>{{ $t('nav.supportingOrganizers') }}<span class="ranking">{{ $t('nav.ranking') }}</span></p>
                        
                        <div class="flex">
                            <img src="https://sup-all.oss-cn-hongkong.aliyuncs.com/bookfairbj/upload/zc-logo.svg"
                                    alt="" />
                            <!-- <img class="zc-1" src="https://sup-all.oss-cn-hongkong.aliyuncs.com/media-library/bookfairbj/upload/zc-1.svg" alt="">
                            <img class="zc-2" src="https://sup-all.oss-cn-hongkong.aliyuncs.com/media-library/bookfairbj/upload/zc-2.svg" alt="">
                            <img src="https://sup-all.oss-cn-hongkong.aliyuncs.com/media-library/bookfairbj/upload/zc-3.svg" alt="">
                            <img src="https://sup-all.oss-cn-hongkong.aliyuncs.com/media-library/bookfairbj/upload/zc-4.svg" alt="">
                            <img src="https://sup-all.oss-cn-hongkong.aliyuncs.com/media-library/bookfairbj/upload/zc-5.svg" alt=""> -->
                        </div>
                    </div>
                </div>
            </div>
            <div :class="['nav-content-bg', { 'fixed-nav': isFixed }]">
                <div class="nav-content">
                    <div class="mobile-menu-btn" @click="showMobileMenu = true">
                        <i class="el-icon-menu"></i>
                    </div>
                    <div class="nav-menu">
                        <img v-if="isFixed" class="hkp_logo_A" src="https://cdn.runderful.cn/media-library/bookfairbj/upload/hkp_logo_A.png" alt="香港馆书展">
                        <router-link to="/" class="nav-item" exact>{{ $t('nav.home') }}</router-link>
                        <el-dropdown trigger="hover" class="nav-item"
                            :class="{ 'router-link-active': $route.path.includes('exhibition-area') }">
                            <span class="el-dropdown-link">
                                {{ $t('nav.exhibition') }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <router-link class="exhibition-item" to="/exhibition-area?type=1">
                                    <el-dropdown-item>{{ $t('nav.publications') }}</el-dropdown-item>
                                </router-link>
                                <router-link class="exhibition-item" to="/exhibition-area?type=2">
                                    <el-dropdown-item>{{ $t('nav.printing') }}</el-dropdown-item>
                                </router-link>
                                <router-link class="exhibition-item" to="/exhibition-area?type=3">
                                    <el-dropdown-item>{{ $t('nav.artInstallationsAndCrafts') }}</el-dropdown-item>
                                </router-link>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <router-link to="/exhibits" class="nav-item">{{ $t('nav.exhibits') }}</router-link>
                        <!-- <router-link to="/exhibitors" class="nav-item">{{ $t('nav.exhibitors') }}</router-link> -->
                        <router-link to="/sponsors" class="nav-item">{{ $t('nav.sponsors') }}</router-link>
                        <!-- <router-link to="www.hkbibf.com/" class="nav-item">{{ $t('nav.officialWebsite') }}</router-link> -->
                        <a href="https://www.hkbibf.com/" class="nav-item" target="_blank">{{ $t('nav.officialWebsite') }}</a>
                    </div>
                    <div class="nav-right">
                        <el-dropdown trigger="click" @command="handleLanguageChange">
                            <span class="el-dropdown-link">
                                {{ currentLanguage }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="zh-Hant">繁</el-dropdown-item>
                                <el-dropdown-item command="zh-Hans">简</el-dropdown-item>
                                <!-- <el-dropdown-item command="en">En</el-dropdown-item> -->
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </nav>
        <router-view class="main-content" />
        <Footer />
        <el-drawer :visible.sync="showMobileMenu" direction="ltr" size="80%" class="mobile-menu-drawer">
            <div class="mobile-menu">
                <router-link to="/" class="mobile-nav-item" @click.native="showMobileMenu = false">{{ $t('nav.home')
                }}</router-link>
                <el-collapse accordion>
                    <el-collapse-item :title="$t('nav.exhibition')">
                        <router-link to="/exhibition-area?type=1" class="mobile-nav-item" style="display: block;"
                            @click.native="showMobileMenu = false">{{ $t('nav.publications') }}</router-link>
                        <router-link to="/exhibition-area?type=2" class="mobile-nav-item" style="display: block;"
                            @click.native="showMobileMenu = false">{{
                                $t('nav.printing') }}</router-link>
                        <router-link to="/exhibition-area?type=3" class="mobile-nav-item" style="display: block;"
                            @click.native="showMobileMenu = false">{{ $t('nav.artInstallationsAndCrafts') }}</router-link>
                        
                    </el-collapse-item>
                </el-collapse>
                <router-link to="/exhibits" class="mobile-nav-item" @click.native="showMobileMenu = false">{{
                    $t('nav.exhibits') }}</router-link>
                <!-- <router-link to="/exhibitors" class="mobile-nav-item" @click.native="showMobileMenu = false">{{
                    $t('nav.exhibitors') }}</router-link> -->
                <router-link to="/sponsors" class="mobile-nav-item" @click.native="showMobileMenu = false">{{
                    $t('nav.sponsors') }}</router-link>
                    
                    <a href="https://www.hkbibf.com/" class="mobile-nav-item">{{ $t('nav.officialWebsite') }}</a>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import Footer from '@/components/footer.vue'

export default {
    name: 'App',
    components: {
        Footer
    },
    data() {
        return {
            showMobileMenu: false,
            isFixed: false
        }
    },
    computed: {
        currentLanguage() {
            const langMap = {
                'zh-Hant': '繁',
                'zh-Hans': '简',
                'en': 'En'
            }
            return langMap[this.$i18n.locale]
        }
    },
    methods: {
        handleLanguageChange(lang) {
            this.$i18n.locale = lang

            this.$store.dispatch('setLanguage', lang)
        },
        handleScroll() {
            this.isFixed = window.scrollY > 0;
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>

<style lang="scss">
.mourning {
      filter:grayscale(100%);
      /* filter:gray的意思就是说给页面加上一个灰度的滤镜 */
      -webkit-filter:grayscale(100%);
      -moz-filter:grayscale(100%);
      -ms-filter:grayscale(100%);
      -o-filter:grayscale(100%);
      filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
      -webkit-filter:grayscale(1)
  }
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

#app {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
        Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

.exhibition-item {
    text-decoration: none !important;
}

.nav-bar {
    
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    // position: fixed;
    // top: 0;
    // left: 0;
    // right: 0;
    // z-index: 1000;

    .mobile-menu-btn {
        display: none;
    }

    .nav-content-bg {
        background: #07BFDD;
        transition: top 0.3s ease;
    }

    .fixed-nav {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        transition: top 0.3s ease;
    }

    .main-content {
        margin-top: 60px;
        min-height: calc(100vh - 60px);
        // background-color: #f5f5f5;
    }

    .nav-content,
    .logos {
        max-width: 1300px;
        margin: 0 auto;
        padding: 0 20px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .logos {
        width: 1120px;
        display: flex;
        height: auto;
        flex-direction: column; // Stack logos vertically
        align-items: center;
        margin-bottom: 10px; // Add some space between logos and nav-menu

        .hkp_logo {
            width: 210px;
        }

        .header-logo-item {
            display: flex;
            justify-content: center;
            gap: 2rem;
            width: 100%;
            margin-bottom: .5rem;

            // .logo-3 {
            //     max-width: 85px;
            // }
            // .logo-6 {
            //     max-width: 300px;
            // }
            // .logo-1 {
            //     max-width: 320px;
            // }
        }
        .header-logo-item-down {
            justify-content: center;
            margin-left: -8.5rem;
            @media (max-width: 768px) {
                margin-left: 0rem;
            }
        }
        .flex {
            display: flex;
            align-items: center;
            justify-content: space-around;
            gap: 3rem;
        }
    }

    @keyframes fadeIn {
        0% {
            background: #07BFDD;
        }

        100% {
            background: #f15922;
        }
    }


    .nav-menu {
        display: flex;
        align-items: center;
        gap: 10px;
        .hkp_logo_A {
            height: 60px;
            // margin-right: -30px;
        }

        .nav-item {
            text-decoration: none;
            color: #fff;
            line-height: 60px;
            padding: 0 20px;
            font-weight: bold;
            font-size: 16px;
            transition: color 0.3s ease;


            &:hover,
            &.router-link-active {
                animation: fadeIn 0.3s forwards;
            }
        }

        .el-dropdown {
            .el-dropdown-link {
                color: #fff;
                font-weight: bold;
                cursor: pointer;
                font-size: 16px;

                &:hover {
                    color: #fff;
                }
            }
        }
    }

    .nav-right {
        .el-dropdown-link {
            cursor: pointer;
            color: #2c3e50;

            &:hover {
                color: #fff;
            }
        }
    }
}

.main-content {
    margin-top: 60px;
    min-height: calc(100vh - 60px);
    // padding: 20px;
    // background-color: #f5f5f5;
}
.header-logo-item-info {
    p {
        margin-bottom: .5rem;
    }
    img {
        height: 2.8rem;
    }
    .co-organizers {
        margin-top: 1rem;
        @media (max-width: 768px) {
            margin-top: .5rem;
        }
    }
    // .zc-1 {
    //     height: 3rem;
    // }
    // .zc-2 {
    //     height: 2.4rem;
    // }
    .ranking {
        font-size: 10px;
        color: #959595;
    }
}
    .organiser-img {
        img {
            height: 5rem;
        }
    }

@media screen and (max-width: 1024px) {
    .nav-bar {
        .nav-menu {
            gap: 15px;

            .nav-item {
                font-size: 14px;
            }
        }
    }
}
@media screen and (max-width: 1162px) { 
    .mobile-menu-btn {
        display: block !important;
    }
    .nav-menu {
        display: none !important;
    }
}
@media screen and (max-width: 768px) {
    .header-logo-item {
        gap: unset !important;
        justify-content: space-between !important;
        margin-bottom: .2rem;
    }
    .nav-bar {
        .nav-menu {
            display: none;
        }

        .nav-content {
            padding: 0 15px;
        }
        .logos {
            width: 100%;
        }

        .hkp_logo {
            width: 160px !important;
        }

        .header-logo-item-info {
            p {
                font-size: 14px;
            }

            
            // .logo-3 {
            //     width: 30px;
            // }
            // .logo-6 {
            //     width: 100px;
            // }
            // .logo-1 {
            //     width: 100px;
            // }
            .flex {
                // flex-wrap: wrap;
                gap: .5rem;
                img {
                    max-height: 1.2rem;
                }
            }
            .zc-1 {
                max-height: 1rem !important;
            }
            .zc-2 {
                max-height: .8rem !important;
            }
        }
            .organiser-img {
                img {
                    max-height: 2.2rem !important;
                }
            }
    }

    .main-content {
        padding: 15px;
    }

    .mobile-menu-btn {
        display: block !important;
        // position: absolute;
        // right: 15px;
        // top: 15px;
        font-size: 24px;
        cursor: pointer;
        z-index: 1001;
        color: #2c3e50;

        &:hover {
            color: #07BFDD;
        }
    }

    .mobile-menu-drawer {
        .el-drawer__body {
            padding: 20px 0;
        }
    }

    .mobile-menu {
        .mobile-nav-item {
            display: block;
            padding: 15px 20px;
            color: #2c3e50;
            text-decoration: none;
            font-size: 16px;
            border-bottom: 1px solid #eee;

            &:hover,
            &.router-link-exact-active {
                // color: #07BFDD;
                animation: fadeIn 0.3s forwards;
            }
        }

        .el-collapse {
            border: none;

            .el-collapse-item__header {
                padding: 15px 20px;
                font-size: 16px;
                color: #2c3e50;
            }

            .el-collapse-item__content {
                padding-bottom: 0;
            }
        }
    }
}
</style>
